import '../styles/recording.css'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GLOBALTYPES } from '../redux/actions/GlobalTypes';
import { update_credit } from '../redux/actions/PaymentAction';
import { postDataAPI } from '../utils/FetchData';
import Shortcut from '../components/Home/Shortcut';
import Navbar from '../components/Navbar';
import { get_user_credits } from '../redux/actions/UserAction';
import Loading from '../components/Loader/Loading';
import BasicHome from '../components/Home/BasicHome';
import ProHome from '../components/Home/ProHome';
const OPENAI_KEY = process.env.REACT_APP_OPENAI_KEY


function Home() {
    const isPro = useSelector(state => state.user?.toggle)

    return (
        <>

            <Navbar />
            {
                isPro ? <ProHome /> : <BasicHome />
            }

        </>
    )
}

export default Home;